export default __webpack_public_path__ + "static/media/youtube.027217ad.svg";